import { render, staticRenderFns } from "./costAdTask.vue?vue&type=template&id=33cea4fe&scoped=true"
import script from "./costAdTask.vue?vue&type=script&lang=js"
export * from "./costAdTask.vue?vue&type=script&lang=js"
import style0 from "./costAdTask.vue?vue&type=style&index=0&id=33cea4fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cea4fe",
  null
  
)

export default component.exports